var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('header',[_c('xiaxin-header')],1),_c('router-view'),_c('footer',{staticClass:"footer"},[_c('xiaxin-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }